/** @typedef {import('../types/database').Profile} Profile */

export const DEFAULT_NOTIFICATION_PREFS = {
  gate_reminders: true,
  raid_digest: true,
  status_report_due: true,
};

export const DEFAULT_UI_PREFS = {
  programme_filter: 'active',
  sidebar_collapsed: false,
};

export const LANDING_PAGES = {
  home: '/home',
  last_project: null,
};

/**
 * @param {Profile|null|undefined} profile
 */
export function getDisplayName(profile) {
  const preferred = profile?.preferred_name?.trim();
  if (preferred) return preferred;
  return profile?.full_name?.trim() || profile?.email?.split('@')[0] || 'User';
}

/**
 * @param {unknown} raw
 */
export function parseNotificationPrefs(raw) {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_NOTIFICATION_PREFS };
  return {
    gate_reminders: raw.gate_reminders !== false,
    raid_digest: raw.raid_digest !== false,
    status_report_due: raw.status_report_due !== false,
  };
}

/**
 * @param {unknown} raw
 */
export function parseUiPrefs(raw) {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_UI_PREFS };
  return {
    programme_filter: raw.programme_filter === 'closed' ? 'closed' : 'active',
    sidebar_collapsed: Boolean(raw.sidebar_collapsed),
  };
}

/**
 * Resolve where to send the user after login when no explicit return path is set.
 * @param {Profile|null|undefined} profile
 * @param {string|null} explicitReturn
 */
export function resolvePostLoginPath(profile, explicitReturn = null) {
  if (explicitReturn) return explicitReturn;
  const landing = profile?.default_landing_page || 'home';
  if (landing === 'last_project' && profile?.last_project_id) {
    return `/project/${profile.last_project_id}`;
  }
  return '/home';
}
